export const APP_COLORS = Object.freeze({
  yellow: "#FBDD65",
  purple: "#898FDD",
  green: "#8FE58B",
  red: "#E65974",
  grey: "#808080",
  tintGreen: "#53DDCC",
  shadowColor: "#C4C4C4", // 1 session #2D6A4F, 2.
  offPink: "#F69DC0",
  dateBackgroundColor: "#E8E8E8",
  successColor: "#2D6A4F",
  warningColor: "#52B788",
  errorColor: "#B7E4C7",
  notSubmittedColor: "#E65974",
  white: "#FFFFFF",
  blue: "#b3e6ff",
  lemon: "#FCE37F",
  lowYellow: "#FCE898",
  offPinkMedium: "#F9BED5",
  offPinkLight: "#FBCEE0",
  black: "#000000",
  placeHolder: "#666666",
  placeHolderBackground: "#ECEFF2",
  orange: "#FF9374",
  errorText: "#5F2120",
  errorBackgroundColor: "#FCEDEC",
  noCompleted: "#E65974", // 3 Session
  halfCompleted: "#ED8E00", // medium green, 2 Session
  oneCompleted: "#EDD500", // #B7E4C7 1 Sessions
  fullCompleted: "#2D6A4F",
});
